export default __webpack_public_path__ + "static/media/5667-niftynaut.275f35ce.pdf";